// import CoupangAd from "./CoupangAd";
import "./CoupangAds.css";
// import CoupangBannerImg from '../../assets/images/coupang-banner.png';
const CoupangAds = () => {
  // tính theo tỉ lệ 400px làm mốc để scale banner
  const width = window.innerWidth * 2.5;
  const height = window.innerWidth / 2;
  const default_margin_left = -183
  const default_margin_top = -(window.innerWidth > 400 ? 60 : 55)
  if ((window as any)._APP_LANG !== "ko") {
    return <></>;
  }
  return (
    <div className="coupang-ads bg-white">

      <div className={`transform scale-[.4]`}
        style={{
          marginLeft: `${default_margin_left * (window.innerWidth / 400)}px`,
          marginTop: `${default_margin_top * (window.innerWidth / 400)}px`,
        }}
      >
        {/* <iframe
          src="https://ads-partners.coupang.com/widgets.html?id=826516&template=carousel&trackingCode=AF7908926&subId=&width=550&height=80&tsource="
          width="550"
          height="80"
          frameBorder="0"
          scrolling="no"
          referrerPolicy="unsafe-url"
        ></iframe> */}
        {/*<img src="https://thumbnail10.coupangcdn.com/thumbnails/remote/500x500ex/image/retail/images/6337595723873993-f73775d5-9de9-435e-b29e-a8a783a25e5d.jpg" width="120" height="120" />*/}
        <iframe
          id="coupang-banner"
          src={`https://ads-partners.coupang.com/widgets.html?id=826516&template=carousel&trackingCode=AF7908926&subId=&width=${width}&height=${height}&tsource=`}
          width={width}
          height={height}
          frameBorder="0"
          scrolling="no"
          referrerPolicy="unsafe-url"
        ></iframe>
      </div>
    </div>
  );
};

export default CoupangAds;
